import { parseInt } from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import PresenceGql from '@/store/graphql/presence/queries/Presence.gql';
import SetPresenceGql from '@/store/graphql/presence/mutations/SetPresence.gql';

// Generic, system-wide presence API. `scope` is a feature area ('communication',
// 'admin', …) and `context` an opaque per-scope locator ('conversation:5', …).
export default {
    fetchPresence: (scope, cmsID) =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: PresenceGql,
                    fetchPolicy: 'network-only',
                    variables: { scope, cms_id: parseInt(cmsID, 10) }
                })
                .then(({ data }) => resolve(data.Presence || []))
                .catch(err => reject(err));
        }),

    setPresence: (scope, cmsID, context, instanceID) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SetPresenceGql,
                    variables: { scope, cms_id: parseInt(cmsID, 10), context: context || null, instance_id: instanceID }
                })
                .then(({ data }) => resolve(data.SetPresence || []))
                .catch(err => reject(err));
        })
};
